import { toEncrypt, toDecrypt } from "./encryptionUtils";
import { constantsSession } from "../constants/constants";

// Función auxiliar para limpiar strings y evitar inyecciones básicas
const hardSanitize = (val) => {
  if (typeof val !== 'string') return val;

  // Elimina caracteres que podrían usarse para XSS o inyecciones de storage
  return val.replace(/[<>]/g, '');
};

export const updateStorage = (
  name = '',
  value = null,
  convert = true,
  isLocal = false,
  sanitizer = (v) => v
) => {

   // 1. Sanitización de la llave y el valor
  const safeName = hardSanitize(name);
  const safeValue = sanitizer(value);

  const storage = isLocal ? localStorage : sessionStorage;

   // 2. Manejo de nulidad (Corrección del bug de sessionStorage)
  if (safeValue === null || safeValue === undefined) {
    storage.removeItem(safeName);

    return;
  }
    // 3. Cifrado
  const encryptedValue = toEncrypt(safeValue, safeName, convert);

  // 4. Persistencia
  storage.setItem(safeName, encryptedValue);
};

export const getItemStorage = (name, parser = true, isLocal = false, validator = () => true) => {

  // Validamos el nombre de la llave antes de usarla
  const safeName = hardSanitize(name);
  const storage = isLocal ? localStorage : sessionStorage;

  const value = storage.getItem(safeName);

  if (value) {
    try {

      const decrypted = toDecrypt(value, safeName, parser);
      // Validación estricta del contenido recuperado
      if (!decrypted || !validator(decrypted)) {
        storage.removeItem(safeName);

        return null;
      }

      return decrypted;
    }
    catch (e) {
      storage.removeItem(safeName);

      return null;
    }
  }
}


  export const clearStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
  };

  export const checkRoles = () => {
    return getItemStorage(constantsSession.ROLES_ME, true);
  };

  export const checkRol = (rolParam) => {
    const myRols = checkRoles();
    return Boolean(myRols?.find((rol) => rol.nombre.includes(rolParam)));
  };

